import * as React from 'react';
import * as styles from './navigation.module.scss';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import {
  ListItem,
  ListItemIcon,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  withStyles,
  createStyles,
  ListItemSecondaryAction,
  IconButton
} from '@material-ui/core';
import Navigation from '../../../../models/navigation';
import InputBase from '@material-ui/core/InputBase';
import { DraggableProvided } from 'react-beautiful-dnd';
import Dashboard from '../../../../models/dashboard';
import { Delete } from '@material-ui/icons';
import { fontFamilies } from '../../../../theme/text';

interface Props {
  childNavigation: Navigation;
  provided: DraggableProvided;
  clientDashboards: Dashboard[];
  updateDashboardNavigation: (navigation: Navigation) => void;
  deleteDashboard: (navigation: Navigation) => void;
}

const DashboardInput = withStyles(() =>
  createStyles({
    input: {
      borderRadius: 4,
      position: 'relative',
      border: '1px solid #d1cece',
      padding: '6px',
      fontFamily: fontFamilies.body,
      fontSize: '12px',
      lineHeight: '17px',
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        backgroundColor: 'white'
      }
    }
  })
)(InputBase);

const DashListItem = ({
  childNavigation,
  provided,
  clientDashboards,
  updateDashboardNavigation,
  deleteDashboard
}: Props) => {
  const [dashboard, setDashboard] = React.useState<number>(Number(childNavigation.link));

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setDashboard(Number(event.target.value));
    const linkedDashboard = clientDashboards.find(dashboard => dashboard.reportId === Number(event.target.value));
    const newNavigation = {
      ...childNavigation,
      link: linkedDashboard.reportId.toString(),
      name: linkedDashboard.name,
      description: linkedDashboard.description
    };
    updateDashboardNavigation(newNavigation);
  };

  return (
    <ListItem
      className={styles.navListItem}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      <ListItemIcon className={styles.navListDragIcon}>
        <DragHandleIcon />
      </ListItemIcon>
      <form className={styles.navListForm}>
        <FormControl className={styles.formControl}>
          <InputLabel id={`dashboard-select-${childNavigation.navigationId}`} style={{ display: 'none' }}>
            Dashboard
          </InputLabel>
          <Select
            className={styles.select}
            labelId={`dashboard-select-${childNavigation.navigationId}`}
            value={dashboard}
            onChange={handleChange}
            input={<DashboardInput />}
          >
            {clientDashboards.map(dashboard => (
              <MenuItem value={dashboard.reportId} key={dashboard.reportId}>
                {dashboard.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <ListItemSecondaryAction>
          <IconButton title="Delete" edge="end" aria-label="delete" onClick={() => deleteDashboard(childNavigation)}>
            <Delete style={{ color: '#006da8' }} />
          </IconButton>
        </ListItemSecondaryAction>
      </form>
    </ListItem>
  );
};

export default DashListItem;
